import React, {useCallback, useEffect, useRef, useState} from 'react';

import FaqItemStyled from './FaqItemStyled';
import PosaTemplate from './PosaTemplate';
import PropTypes from 'prop-types';

const FaqItem = ({data, defaultExpand = true}) => {
  const answerRef = useRef();
  const {question, answer} = data;
  const [expand, toggle] = useState(defaultExpand);
  useEffect(() => {
    const ele = answerRef.current;
    if (expand) {
      ele.style.maxHeight = `${ele.scrollHeight}px`;
    } else {
      ele.style.maxHeight = 0;
    }
  });
  const onClick = useCallback(() => {
    toggle(!expand);
  }, [toggle, expand]);
  return (
    <FaqItemStyled expand={expand} className={`ecr-faqItem ${expand ? 'expand' : ''}`}>
      <div className="ecr-faqItem-question" onClick={onClick} role="presentation">
        <h3>{question}</h3>
        <div className="expand-icon" />
      </div>
      <div className="ecr-faqItem-answer" ref={answerRef}>
        <PosaTemplate Tag="div" isTemplate string={answer} />
      </div>
    </FaqItemStyled>
  );
};

FaqItem.propTypes = {
  data: PropTypes.object,
  defaultExpand: PropTypes.bool,
};

export default FaqItem;
